export default __webpack_public_path__ + "static/media/database-svgrepo-com.4a2f4d89.svg";